import { useFormik } from "formik";
import React from "react";
import * as yup from "yup";

import {
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  IconButton,
  TextField,
  Box,
} from "@mui/material";

import { IoCloseOutline } from "react-icons/io5";

function EditClassDialog({ open = true, onClose, onChange, data, course }) {
  const defaultSeats = course.type == "Live Session 1 on 1" ? 1 : "";
  const newClass = {
    _new: true,
    _id: "TEMP_" + new Date() / 1000,
    totalSeats: defaultSeats,
    bookedSeats: 0,
    course: course._id,
    mentors: [],
    sessions: [],
  };

  const validationSchema = yup.object({
    totalSeats: yup
      .number()
      .required()
      .label("Total Seats")
      .min(data?.bookedSeats ? data.bookedSeats : 1)
      .max(1000),
  });

  const formik = useFormik({
    initialValues: data ?? newClass,
    validationSchema: validationSchema,
    onSubmit: (values) => {
      onChange(values);
      onClose();
    },
  });

  return (
    formik.values && (
      <form>
        <Dialog
          open={open}
          keepMounted
          onClose={onClose}
          maxWidth="sm"
          fullWidth
        >
          <DialogTitle>
            <Box display="flex" alignItems="center">
              <Box flexGrow={1}>
                <h2 className="font-extrabold text-lg">
                  {data ? "Edit" : "Create"} Class
                </h2>
              </Box>
              <Box>
                <IconButton onClick={onClose}>
                  <IoCloseOutline />
                </IconButton>
              </Box>
            </Box>
          </DialogTitle>
          <DialogContent>
            <div className="">
              <div className="flex flex-col gap-5">
                <div>
                  <div className="text-sm">
                    <b>Course Type:</b> {course.type}
                  </div>

                  {!formik.values._new && (
                    <div className="text-sm">
                      <b>Booked Seats:</b> {data.bookedSeats}
                    </div>
                  )}
                </div>

                <TextField
                  disabled={course.type != "Live Group Session"}
                  label="Total Seats"
                  variant="filled"
                  type="number"
                  placeholder="Total Seats in Class"
                  size="small"
                  className="col-span-2"
                  name="totalSeats"
                  required
                  fullWidth
                  value={formik.values.totalSeats}
                  onChange={formik.handleChange}
                  onBlur={formik.handleBlur}
                  error={
                    formik.touched.totalSeats &&
                    Boolean(formik.errors.totalSeats)
                  }
                  helperText={
                    formik.touched.totalSeats && formik.errors.totalSeats
                  }
                />
              </div>
            </div>
          </DialogContent>
          <DialogActions>
            <Button type="submit" onClick={formik.handleSubmit}>
              Done
            </Button>
          </DialogActions>
        </Dialog>
      </form>
    )
  );
}

export default EditClassDialog;
